import { Style, Icon, Circle as CircleStyle, Fill } from 'ol/style';
import { CumulativeUsage } from "./hiboo/cumulativeUsage";
import { Exploitation } from "./hiboo/exploitation";

export interface Equipment {
  equipementId?: number; //mariaDB
  externalId?: number; //hiboo
  siteId?: number;
  name?: string;
  model?: string;
  make?: string;
  serialNumber?: string;
  type?: string
  usage?: CumulativeUsage
  exploitation?: Exploitation
  isChecked?: boolean
  displayName?: string;
  typeId?: number;
  co2EqPerDrilledMeter?: number;
}
export class EquipmentUtils {

  static formatEquipmentDisplayName(equipment: Equipment): string {
    const name = equipment.model ? `${equipment.externalId}` : equipment.name;
    return name.length > 10 ? `${name.substring(0, 10)}` : name;
  }

  static getEquipmentType(externalId: number): string {
    return 'HIBOO.EQUIPMENT';
  }

  static getEquipmentTypeFromEquipment(equipment: Equipment): string {
    return equipment.name || equipment.type || 'HIBOO.EQUIPMENT';
  }

 static equipmentStyles = {
    type1: [
      new Style({
        image: new CircleStyle({
          radius: 12,
          fill: new Fill({ color: '#ffffff' }),
        }),
      }),
      new Style({
        image: new Icon({
          src: 'assets/icon/Cat990k.png',
          scale: 0.08,
          anchor: [0.5, 0.5],
        }),
      }),
    ],
    type2: [
      new Style({
        image: new CircleStyle({
          radius: 12,
          fill: new Fill({ color: '#ffffff' }),
        }),
      }),
      new Style({
        image: new Icon({
          src: 'assets/icon/icon-park_truc.svg',
          scale: 0.08,
          anchor: [0.5, 0.5],
        }),
      }),
    ],
    type3: [
      new Style({
        image: new CircleStyle({
          radius: 12,
          fill: new Fill({ color: '#ffffff' }),
        }),
      }),
      new Style({
        image: new Icon({
          src: 'assets/icon/Geotab.png',
          scale: 0.06,
          anchor: [0.5, 0.5],
        }),
      }),
    ],
  };
}
